import { render, staticRenderFns } from "./shopTabbar.vue?vue&type=template&id=451b04d2&scoped=true&"
import script from "./shopTabbar.vue?vue&type=script&lang=js&"
export * from "./shopTabbar.vue?vue&type=script&lang=js&"
import style0 from "./shopTabbar.vue?vue&type=style&index=0&id=451b04d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b04d2",
  null
  
)

export default component.exports